import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@/components/index';
import { Event } from '@/api/bol';

interface EventsDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  event: Event | null;
}

const EventsDeleteDialog: React.FC<EventsDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  event,
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error('Error deleting event:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  if (!event) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Event</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this event? This action is permanent and cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <SecondaryButton onClick={onClose} disabled={isDeleting}>
          Cancel
        </SecondaryButton>
        <PrimaryButton
          onClick={handleConfirm}
          disabled={isDeleting}
          color="error"
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default EventsDeleteDialog;